// セミナー・講演会一覧の絞り込み（種別・製品・月送り）＋ カレンダー表示
// 全件をHTMLに出力しておき、条件マッチで表示/非表示を切り替える（ページ遷移なし）。
// カレンダー（scheduleCalendar.js）は同じ条件を通過したカードから月ごとに生成する。
//
// マークアップ:
//   .js-schedule                 … ルート。data-month-min / data-month-max / data-month-initial（"YYYY-MM"）
//   .js-schedule-type            … 種別ボタン。data-type="" | "web" | "lecture"（"" = 全ての種別）
//   .js-schedule-product         … 製品ボタン。data-product="" | "arikayce" 等（"" = 全ての製品）
//   .js-schedule-year / .js-schedule-month … 表示中の年月ラベル
//   .js-schedule-prev / .js-schedule-today / .js-schedule-next … 月送りボタン
//   .js-schedule-item            … カード。data-classification / data-products（半角スペース区切り）/ data-month（"YYYY-MM"）/ data-date（"YYYY-MM-DD"）
//   .js-schedule-empty           … 該当0件メッセージ
//   .js-schedule-calendar        … カレンダーの描画先（任意）

import { createScheduleCalendar } from './scheduleCalendar';

export const initScheduleFilter = () => {
  const root = document.querySelector('.js-schedule');
  if (!root) return;

  const typeButtons = root.querySelectorAll('.js-schedule-type');
  const productButtons = root.querySelectorAll('.js-schedule-product');
  const yearLabel = root.querySelector('.js-schedule-year');
  const monthLabel = root.querySelector('.js-schedule-month');
  const prevButton = root.querySelector('.js-schedule-prev');
  const todayButton = root.querySelector('.js-schedule-today');
  const nextButton = root.querySelector('.js-schedule-next');
  const items = [...root.querySelectorAll('.js-schedule-item')];
  const emptyMessage = root.querySelector('.js-schedule-empty');
  const calendar = createScheduleCalendar(root);

  // "YYYY-MM" ⇔ 通算月数（比較・加減算用）
  const toMonths = ym => {
    const [year, month] = ym.split('-').map(Number);
    return year * 12 + (month - 1);
  };
  const toYm = months => `${Math.floor(months / 12)}-${String((months % 12) + 1).padStart(2, '0')}`;

  const initialMonth = toMonths(root.dataset.monthInitial);
  const minMonth = toMonths(root.dataset.monthMin);
  const maxMonth = toMonths(root.dataset.monthMax);
  const state = { type: '', product: '', month: initialMonth };

  const apply = () => {
    const ym = toYm(state.month);
    let visibleCount = 0;
    const matchedItems = [];

    items.forEach(item => {
      const matchType = state.type === '' || item.dataset.classification === state.type;
      const matchProduct = state.product === '' || (item.dataset.products || '').split(' ').includes(state.product);
      const matchMonth = item.dataset.month === ym;
      if (matchType && matchProduct) matchedItems.push(item);
      const show = matchType && matchProduct && matchMonth;
      item.style.display = show ? '' : 'none';
      if (show) visibleCount += 1;
    });

    typeButtons.forEach(button => button.classList.toggle('-active', button.dataset.type === state.type));
    productButtons.forEach(button => button.classList.toggle('-active', button.dataset.product === state.product));

    yearLabel.textContent = `${Math.floor(state.month / 12)}年`;
    monthLabel.textContent = `${(state.month % 12) + 1}月`;
    prevButton.disabled = state.month <= minMonth;
    nextButton.disabled = state.month >= maxMonth;

    if (emptyMessage) {
      emptyMessage.style.display = visibleCount ? 'none' : '';
    }
    if (calendar) {
      calendar.render(ym, matchedItems);
    }
  };

  typeButtons.forEach(button => {
    button.addEventListener('click', () => {
      state.type = button.dataset.type;
      apply();
    });
  });
  productButtons.forEach(button => {
    button.addEventListener('click', () => {
      state.product = button.dataset.product;
      apply();
    });
  });
  prevButton.addEventListener('click', () => {
    if (state.month > minMonth) {
      state.month -= 1;
      apply();
    }
  });
  nextButton.addEventListener('click', () => {
    if (state.month < maxMonth) {
      state.month += 1;
      apply();
    }
  });
  todayButton.addEventListener('click', () => {
    state.month = initialMonth;
    apply();
  });

  apply();
};
